export default __webpack_public_path__ + "static/media/FebDom2024.7c6a2e2e.png";